var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-layout" }, [
    _c("div", { staticClass: "container-body" }, [
      _c(
        "div",
        { staticClass: "container-body_content" },
        [
          _c("layout-breadcrumb", {
            staticClass: "container-body_content__breadcrumb",
            scopedSlots: _vm._u([
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "container-body_content__breadcrumb___button",
                        on: { click: _vm.handleClick },
                      },
                      [_c("div")]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("router-view", {
            staticClass: "container-body_content__routerview",
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }